<template>
    <v-hover
        v-slot:default="{ hover }"
        open-delay="200"
    >
        <v-card 
            :elevation="hover ? 16 : 0"
            outlined 
            :to="`/${$i18n.locale}/student/tutor/profile/${tutor.id}`"
            class="custom-radius"
        >
            <div>
                <template v-if="tutor.photo">
                    <div class="image-container" :style="`background-image: url('${baseImageUrl}${tutor.photo}')`"></div>
                </template>
                <template v-else>
                    <div class="image-container"></div>
                </template>
                <div class="title font-weight-medium px-4 text-center" v-text="fullName"></div>
                <div class="subtitle-2 font-weight-light px-4 text-center" v-text="tutor.country.name" tutor.country></div>
                <div class="d-flex align-center justify-center text-center pa-4">
                    <v-rating
                        :value="tutor.rating"
                        dense
                        readonly
                        half-increments
                        size="18"
                        color="orange"
                        class="mr-4"
                        background-color="orange lighten-3"
                    ></v-rating>
                    <span class="grey--text text--darken-1">{{ tutor.rating }} ({{ tutor.reviewCount }})</span>
                </div>
            </div>
            <div class="px-4 pb-4" v-if="!hidesubjects">
                <div class="text-center">
                    <v-chip 
                        small
                        outlined
                        v-for="(subject, index) in tutor.teachingSubjects" 
                        :key="index" 
                        v-text="subject.name"
                        class="ma-1"
                        color="primary"
                    >
                    </v-chip>
                </div>
            </div>
        </v-card>
    </v-hover>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    export default {
        name: 'tutorProfileCard',
        props: {
            tutor: Object,
            hidesubjects: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            fullName() {
                return this.tutor.name + ' ' + this.tutor.lastName
            },
            ...mapGetters(['baseImageUrl'])
        }
    }
</script>

<style lang="scss" scoped>
.v-card{
    height: 100%;
}
.image-container{
    width: 150px;
    height: 150px;
    margin: 15px auto 20px;
    background-color: #ccc;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    border-radius: 100%;
}
@media (max-width: 1263px) {
    .image-container{
        width: 100px;
        height: 100px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
</style>